angular.module('bmsApp.trugreen.quote')
	.controller('TGQuoteSaveCtrl', function ($state,
											 $scope,
											 $timeout,
											 $q,
											 notify,
											 $filter,
											 $ngBootbox,
											 LicenseOptionsSvc,
											 //																		TaxHelperSvc,
											 EnquirySvc,
											 SiteSvc,
											 CustomerSvc,
											 TGAnalysisSvc,
											 TGTreatmentSvc,
											 TGCancelReasonSvc,
											 EmployeeOptionsSvc,
											 QuoteStatusSvc,
											 TGJobSvc,
											 ProximitySvc,
	) {

		$scope.TGQuoteSaveCtrl = {
			isProforma: $state.is('main.trugreen.quote.index.createProforma'),
			updating: $state.is('main.trugreen.quote.index.updateProforma') || $state.is('main.trugreen.quote.index.view.update'),
			creating: $state.is('main.trugreen.quote.index.create'),
			pageTitle: 'Add Quote',
			processing: false,
			loading: true,
			errors: null,
			enquiryId: parseInt($state.params.enquiryId),
			quoteId: parseInt($state.params.quoteId),
			customerId: parseInt($state.params.customerId),
			job: null,
			savedQuoteName: null,
			protos: {
				job: function () {
					return {
						lawn_front_size: 0,
						lawn_rear_size: 0,
						lawn_side_size: 0,
						lawn_other_size: 0,
						treatments: []
					};
				}
			},
			options: {},
			methods: {
				init: function () {
					var loadingPromises = {};
					$scope.TGQuoteSaveCtrl.job = $scope.TGQuoteSaveCtrl.protos.job();
					if ($scope.TGQuoteSaveCtrl.enquiryId) {
						loadingPromises.enquiry = EnquirySvc.read($scope.TGQuoteSaveCtrl.enquiryId);
						angular.extend($scope.TGQuoteSaveCtrl.job, {
							proforma_quote: true
						});
					}
					else if ($scope.TGQuoteSaveCtrl.quoteId) {
						loadingPromises.quote = $scope.TGQuoteSaveCtrl.methods.loadQuote();
					}
					else if ($scope.TGQuoteSaveCtrl.customerId) {
						loadingPromises.customer = CustomerSvc.read($scope.TGQuoteSaveCtrl.customerId);
						$scope.TGQuoteSaveCtrl.methods.setDefaultStatus();
					}
					else {
						angular.extend($scope.TGQuoteSaveCtrl.job, {
							quote: true
						});
						$scope.TGQuoteSaveCtrl.methods.setDefaultStatus();
					}
					loadingPromises.populateFormOptions = $scope.TGQuoteSaveCtrl.methods.populateFormOptions();
					$q.all(loadingPromises)
						.then(function (responses) {
							$scope.TGQuoteSaveCtrl.methods.calcLawnTotalSize();
							$scope.TGQuoteSaveCtrl.loading = false;
							if ($scope.TGQuoteSaveCtrl.enquiryId) {
								var enquiry = responses.enquiry.data.enquiry;
								angular.extend($scope.TGQuoteSaveCtrl.job, {
									enquiry: enquiry,
									license: enquiry.license,
									campaign: enquiry.campaign,
									initiative: enquiry.initiative
								});
								if (enquiry.sales_pipeline) {
									angular.extend($scope.TGQuoteSaveCtrl.job, {
										sales_pipeline: {
											probability: enquiry.sales_pipeline.probability,
											annual_forecast: enquiry.sales_pipeline.annual_forecast
										}
									});
								}
							}
							else if ($scope.TGQuoteSaveCtrl.customerId) {
								var customer = responses.customer.data.customer;
								if (angular.isObject(customer.customer_initiative)) {
									angular.extend($scope.TGQuoteSaveCtrl.job, {
										campaign: customer.customer_initiative.campaign,
										initiative: customer.customer_initiative.initiative,
									});
								}
								else {
									angular.extend($scope.TGQuoteSaveCtrl.job, {
										campaign: null,
										initiative: null,
									})
								}
							}
							$scope.TGQuoteSaveCtrl.methods.setDefaultEnquiryOrCustomer();

						});

					$scope.$watch('TGQuoteSaveCtrl.job.enquiry', function () {
						$scope.TGQuoteSaveCtrl.methods.generateQuoteName();
					});

					$scope.TGQuoteSaveCtrl.job.sales_pipeline = {
						'probability': 0,
						'annual_forecast': 0
					}

				},
				populateFormOptions: function () {
					var optionPromises = {
						enquiryOptions: EnquirySvc.options(),
						customerOptions: CustomerSvc.options(),
						cancelOptions: TGCancelReasonSvc.options(),
						licenseOptions: LicenseOptionsSvc.license(),
						analysisOptions: TGAnalysisSvc.options(),
						preferredEmployeeOptions: EmployeeOptionsSvc.employee({filter: {status: true}}),
						quoteStatusOptions: QuoteStatusSvc.options()
					};

					return $q.all(optionPromises)
						.then(function (responses) {
							$scope.TGQuoteSaveCtrl.options.enquiry = responses.enquiryOptions.data.options;
							$scope.TGQuoteSaveCtrl.options.license = responses.licenseOptions.data.options;
							$scope.TGQuoteSaveCtrl.options.customer = responses.customerOptions.data.options;
							$scope.TGQuoteSaveCtrl.options.cancelReasons = responses.cancelOptions.data.options;
							$scope.TGQuoteSaveCtrl.options.thatch = responses.analysisOptions.data.options_thatch;
							$scope.TGQuoteSaveCtrl.options.soilTypeCondition = responses.analysisOptions.data.options_soil_type_condition;
							$scope.TGQuoteSaveCtrl.options.soilCompaction = responses.analysisOptions.data.options_soil_compaction;
							$scope.TGQuoteSaveCtrl.options.drainage = responses.analysisOptions.data.options_drainage;
							$scope.TGQuoteSaveCtrl.options.grasses = responses.analysisOptions.data.options_grasses;
							$scope.TGQuoteSaveCtrl.options.grassDensity = responses.analysisOptions.data.options_grass_density;
							$scope.TGQuoteSaveCtrl.options.moss = responses.analysisOptions.data.options_moss;
							$scope.TGQuoteSaveCtrl.options.shade = responses.analysisOptions.data.options_shade;
							$scope.TGQuoteSaveCtrl.options.pastTreatments = responses.analysisOptions.data.options_past_treatments;
							$scope.TGQuoteSaveCtrl.options.preferredEmployee = responses.preferredEmployeeOptions.data.options;
							$scope.TGQuoteSaveCtrl.options.quoteStatus = responses.quoteStatusOptions.data.options;
						});
				},
				loadQuote: function () {
					return TGJobSvc.read($scope.TGQuoteSaveCtrl.quoteId)
						.then(function (response) {
							angular.extend($scope.TGQuoteSaveCtrl.job, response.data.tg_job);
							angular.extend($scope, {
								quote: {
									name: angular.copy($scope.TGQuoteSaveCtrl.job.quote_name)
								}
							});

							$scope.TGQuoteSaveCtrl.isProforma = angular.isObject(response.data.tg_job.enquiry);

							if ($scope.TGQuoteSaveCtrl.isProforma) {
								if ($scope.TGQuoteSaveCtrl.job.visits.length) {
									$scope.TGQuoteSaveCtrl.job.visit = $scope.TGQuoteSaveCtrl.job.visits[0];
								}
							}

							$scope.TGQuoteSaveCtrl.savedQuoteName = $scope.TGQuoteSaveCtrl.job.quote_name;
							if ($scope.TGQuoteSaveCtrl.job.customer) {
								angular.extend($scope.TGQuoteSaveCtrl.job, {
									quote: true
								});
								$scope.TGQuoteSaveCtrl.eventHandlers.customerChanged();
							}
						});
				},
				calcLawnTotalSize: function () {
					var job = $scope.TGQuoteSaveCtrl.job;
					job.lawn_total_size = parseFloat(job.lawn_front_size) + parseFloat(job.lawn_rear_size) + parseFloat(job.lawn_side_size) + parseFloat(job.lawn_other_size);
				},
				promptUpdateTreatments: function (oldJob) {
					$ngBootbox.confirm("Would you like to save the new lawn sizes and update treatment prices based on the new total lawn size? " +
						"<br><br><span class='alert alert-warning show'>" +
						"<b>Warning:</b><br> - Treatments with a custom lawn size won't factor into the updated overall job lawn size" +
						"<br> - Treatments with a custom selling price will be ignored" +
						"</span>")
						.then(function () {
							TGJobSvc.updateJobTreatments($scope.TGQuoteSaveCtrl.job, oldJob);
						});
				},
				addTreatment: function () {
					TGTreatmentSvc.showJobTreatmentModal($scope.TGQuoteSaveCtrl.job)
						.then(function (result) {
							$scope.TGQuoteSaveCtrl.job.treatments.push(result.jobTreatment);
						});
				},
				editTreatment: function (jobTreatment) {
					TGTreatmentSvc.showJobTreatmentModal($scope.TGQuoteSaveCtrl.job, jobTreatment)
						.then(function (result) {
							angular.extend(jobTreatment, result.jobTreatment);
						});
				},
				removeTreatment: function (jobTreatment) {
					$ngBootbox.confirm('Are you sure you want to do this?')
						.then(function () {
							angular.extend(jobTreatment, {
								delete: true
							});
						});
				},
				setDefaultStatus: function () {
					$scope.TGQuoteSaveCtrl.job.quote_status = {id: 1};
				},
				showProximityLocatorModal: function () {
					var postcode = '';
					if($scope.TGQuoteSaveCtrl.job.site){
						postcode = $scope.TGQuoteSaveCtrl.job.site.postcode;
					} else if($scope.TGQuoteSaveCtrl.job.enquiry) {
						postcode = $scope.TGQuoteSaveCtrl.job.enquiry.postcode;
					}
					ProximitySvc.showLocatorModal($scope.TGQuoteSaveCtrl.job.license, postcode);
				},

				setDefaultEnquiryOrCustomer: function () {
					if ($scope.TGQuoteSaveCtrl.enquiryId) {
						var defaultEnquiry = $filter('filter')($scope.TGQuoteSaveCtrl.options.enquiry, {
							id: parseInt($scope.TGQuoteSaveCtrl.enquiryId)
						}, true);

						if (angular.isArray(defaultEnquiry) && defaultEnquiry.length) {
							angular.extend($scope.TGQuoteSaveCtrl.job, {
								enquiry: defaultEnquiry[0]
							});
						}
					}
					else if ($scope.TGQuoteSaveCtrl.customerId) {
						var defaultCustomer = $filter('filter')($scope.TGQuoteSaveCtrl.options.customer, {
							id: parseInt($scope.TGQuoteSaveCtrl.customerId)
						}, true);

						if (angular.isArray(defaultCustomer) && defaultCustomer.length) {
							angular.extend($scope.TGQuoteSaveCtrl.job, {
								customer: defaultCustomer[0]
							});
							$scope.TGQuoteSaveCtrl.eventHandlers.customerChanged();

							// Set the license
							var defaultLicense = $filter('filter')($scope.TGQuoteSaveCtrl.options.license, {
								id: parseInt($scope.TGQuoteSaveCtrl.job.customer.license.id)
							}, true);

							// Set the default campaign from the customer


							angular.extend($scope.TGQuoteSaveCtrl.job, {
								license: defaultLicense[0]
							});
						}
					}
				},
				generateQuoteName: function () {
					// update quote name if it hasn't already been saved
					if (!$scope.TGQuoteSaveCtrl.savedQuoteName) {
						if (angular.isObject($scope.TGQuoteSaveCtrl.job.enquiry)) {
							var lastName = $scope.TGQuoteSaveCtrl.job.enquiry.last_name.toUpperCase();
							$scope.TGQuoteSaveCtrl.job.quote_name = lastName + '-' + moment()
								.format('MMM-D-YYYY')
								.toUpperCase();
						}
						else if (angular.isObject($scope.TGQuoteSaveCtrl.job.customer)) {
							var lastName = $scope.TGQuoteSaveCtrl.job.customer.value.split(' ')
								.pop()
								.trim()
								.toUpperCase();
							var quoteName = lastName + '-' + moment()
								.format('MMM-D-YYYY')
								.toUpperCase();
							$scope.TGQuoteSaveCtrl.job.quote_name = lastName + '-' + moment()
								.format('MMM-D-YYYY')
								.toUpperCase();
						}
						else {
							$scope.TGQuoteSaveCtrl.job.quote_name = '';
						}
					}
				},
				getTreatmentAreasList: function (jobTreatment) {
					return TGTreatmentSvc.getTreatmentAreasList(jobTreatment);
				},
				visitplanner: function () {
					// save the quote first
					$scope.TGQuoteSaveCtrl.methods.submit(true);
				},
				onQuoteStatusChanged: function () {
					if ($scope.TGQuoteSaveCtrl.job.quote_status.value === 'Lost') {

					}
				},
				submit: function (redirectToVisitPlanner) {
					$timeout(function () {
						$scope.$apply(function () {
							$scope.TGQuoteSaveCtrl.processing = true;
						});
					});
					TGJobSvc.save($scope.TGQuoteSaveCtrl.job)
						.then(function (response) {
							var message = '';
							if ($scope.TGQuoteSaveCtrl.isProforma) {
								message = $scope.TGQuoteSaveCtrl.updating ? 'Proforma quote updated successfully' : 'Proforma quote created successfully'
							}
							else {
								message = $scope.TGQuoteSaveCtrl.updating ? 'Quote updated successfully' : 'Quote created successfully'
							}

							notify({
								message: message
							});
							if (redirectToVisitPlanner) {
								$state.go('main.trugreen.visitplanner', {
									quoteId: response.data.tg_job.id,
									return: 'edit-quote'
								});
							}
							else {
								if ($scope.TGQuoteSaveCtrl.isProforma) {
									// go back to enquiry and replace history
									$state.go('main.crm.enquiry.index.view', {enquiryId: response.data.tg_job.enquiry.id}, {location: 'replace'});
								}
								else {
									$state.go('main.trugreen.quote.index.view', {quoteId: response.data.tg_job.id}, {location: 'replace'});
								}
							}
						}, function (error) {
							$scope.TGQuoteSaveCtrl.errors = error;
						})
						.finally(function () {
							$scope.TGQuoteSaveCtrl.processing = false;
						});
				}
			},
			eventHandlers: {
				onLawnSizeChange: function (oldJob) {
					$scope.TGQuoteSaveCtrl.methods.calcLawnTotalSize();
					if ($scope.TGQuoteSaveCtrl.job.treatments.length > 0) {
						$scope.TGQuoteSaveCtrl.methods.promptUpdateTreatments(oldJob);
					}
				},
				enquiryChanged: function () {
					if ($scope.TGQuoteSaveCtrl.job.enquiry) {
						// load enquiry and set sales pipeline status to match enquiry is it has one
						EnquirySvc.read($scope.TGQuoteSaveCtrl.job.enquiry.id)
							.then(function (response) {
								if (response.data.enquiry.sales_pipeline) {
									angular.extend($scope.TGQuoteSaveCtrl.job, {
										sales_pipeline: {
											probability: response.data.enquiry.sales_pipeline.probability,
											annual_forecast: response.data.enquiry.sales_pipeline.annual_forecast
										}
									});
								}
							});
					}
				},
				customerChanged: function () {
					CustomerSvc.read($scope.TGQuoteSaveCtrl.job.customer.id)
						.then(function (response) {
							if (response.data.customer.sales_pipeline) {
								$scope.TGQuoteSaveCtrl.job.sales_pipeline = response.data.customer.sales_pipeline;
							}
							else if (!$scope.TGQuoteSaveCtrl.updating) {
								$scope.TGQuoteSaveCtrl.job.sales_pipeline = {
									'probability': 0,
									'annual_forecast': 0
								}
							}

							if (!$scope.TGQuoteSaveCtrl.updating) {
								if (angular.isObject(response.data.customer.customer_initiative)) {
									angular.extend($scope.TGQuoteSaveCtrl.job, {
										campaign: response.data.customer.customer_initiative.campaign,
										initiative: response.data.customer.customer_initiative.initiative,
									});
								}
								else {
									angular.extend($scope.TGQuoteSaveCtrl.job, {
										campaign: null,
										initiative: null,
									})
								}
							}
						});
					// Set the quote name
					$scope.TGQuoteSaveCtrl.methods.generateQuoteName();
					SiteSvc.customerOptions($scope.TGQuoteSaveCtrl.job.customer.id)
						.then(function (response) {
							$scope.TGQuoteSaveCtrl.options.site = response.data.options;
							if ($scope.TGQuoteSaveCtrl.options.site.length == 1) {
								$scope.TGQuoteSaveCtrl.job.site = $scope.TGQuoteSaveCtrl.options.site[0]; // select only site by default
							}
						});
				}
			},
			formvalidatorconfig: {
				submitHandler: function () {
					$scope.TGQuoteSaveCtrl.methods.submit(false);
				},
				errorPlacement: function (error) {
					error.appendTo('#job-errors');
				},
				errorContainer: '#job-errors'
			}
		};

	});
